import React from "react";
import point from "./../../../Images/point.png";

const UnisexHairSalonNearMeDiff = () => {
  return (
    <div className="hairSalonNearMeWhy">
      <h5>Why SCENT is the Go-To Hair Salon Near Me</h5>
      <p>
        With so many salons to choose from, finding the perfect hair salon near
        me can be a challenge. But SCENT stands out for several reasons:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Personalized Consultations{" "}
          </span>
          <p>
            At SCENT, we believe in offering a personalized experience for every
            client. Our stylists take the time to listen to your needs,
            preferences, and concerns before recommending the best services for
            you. Whether you’re unsure about which haircut will suit you or you
            need advice on hair treatments, SCENT is the unisex hair salon near
            me where the consultation process is all about you.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Premium Products:{" "}
          </span>
          <p>
            We believe that excellent hair services start with excellent
            products. SCENT uses top-tier, salon-quality products that nourish
            and protect your hair. We choose products that cater to all hair
            types and textures, ensuring that both men and women get the care
            they deserve. If you're looking for a unisex hair salon near me that
            uses premium, cruelty-free products, SCENT is the ideal choice.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Commitment to Customer Satisfaction
          </span>
          <p>
            At SCENT, our clients are at the heart of everything we do. We go
            above and beyond to make sure you leave with the look you want and
            the confidence you deserve. Every stylist at our unisex hair salon
            near me is dedicated to providing exceptional service and ensuring
            that your experience is nothing short of perfect.
          </p>
        </li>{" "}
       
      </ul>
    </div>
  );
};

export default UnisexHairSalonNearMeDiff;
